import React, { useState, useEffect } from 'react';
import { Globe, Clock, Sparkles } from 'lucide-react';

const CITIES = [
  { id: 'us', flag: '🇺🇸', name: 'USA', city: 'New York', tz: 'America/New_York', code: 'EDT' },
  { id: 'uk', flag: '🇬🇧', name: 'UK', city: 'London', tz: 'Europe/London', code: 'BST' },
  { id: 'ca', flag: '🇨🇦', name: 'Canada', city: 'Toronto', tz: 'America/Toronto', code: 'EDT' },
  { id: 'au', flag: '🇦🇺', name: 'Australia', city: 'Sydney', tz: 'Australia/Sydney', code: 'AEDT' }
];

export function WorldBusinessClock() {
  const [mounted, setMounted] = useState(false);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    setMounted(true);
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatCityTime = (tz) => {
    try {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }).format(now);
    } catch {
      return '--:--:--';
    }
  };

  const getBusinessStatus = (tz) => {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour: 'numeric',
        hour12: false,
        weekday: 'short'
      }).formatToParts(now);

      const hour = parseInt(parts.find(p => p.type === 'hour')?.value || '12', 10);
      const day = parts.find(p => p.type === 'weekday')?.value || 'Mon';
      const isWeekend = day === 'Sat' || day === 'Sun';

      if (!isWeekend && hour >= 9 && hour < 17) {
        return { label: 'Open', isOpen: true };
      }
      return { label: 'Closed', isOpen: false };
    } catch {
      return { label: 'Closed', isOpen: false };
    }
  };

  return (
    <div className="world-clock-topbar" aria-label="Global Business Markets Live Clock">
      <div className="container world-clock-inner">
        <div className="world-clock-lead">
          <Globe size={13} className="world-icon" />
          <span className="lead-text">Global Business Hours</span>
          <span className="live-badge">
            <span className="live-clock-dot"></span> LIVE
          </span>
        </div>

        <div className="world-clock-grid">
          {CITIES.map((c) => {
            const timeStr = mounted ? formatCityTime(c.tz) : '--:--:--';
            const status = mounted ? getBusinessStatus(c.tz) : { label: 'Market', isOpen: false };
            return (
              <div key={c.id} className="clock-city-pill" title={`${c.name} (${c.city}) Business Time`}>
                <span className="city-flag">{c.flag}</span>
                <span className="city-name">{c.name}:</span>
                <time className="city-time" suppressHydrationWarning>{timeStr}</time>
                <span className="city-code">{c.code}</span>
                <span className={`market-dot ${status.isOpen ? 'open' : 'closed'}`} title={`Markets ${status.label}`}></span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
